(ns common.schema.entities.workspace.kyc.templates.lifeline.controlling-person
  (:require
   [common.schema.entities.workspace.kyc.questions.questions-registry :as questions-registry]))

(defn process-not-in-draft-status?
  [_answers kyc-process]
  (not= (:kyc-process/status kyc-process)
        :kyc-process.status/draft))

(def schema
  {:kyc-template/template-name
   "Controlling Person"
   :kyc-template/kyc-form-preface
   {:translations {:en "Controlling Person information"
                   :fi "Määräysvaltaisen henkilön tiedot"}}

   :kyc-controlling-person.group/basic-information
   {:ord          1.0
    :translations {:en "Basic information"
                   :fi "Perustiedot"}
    :questions    (questions-registry/resolve-questions
                   [[:kyc-controlling-person/first-name {:mandatory-field? process-not-in-draft-status?}]
                    [:kyc-controlling-person/last-name {:mandatory-field? process-not-in-draft-status?}]
                    [:kyc-controlling-person/middle-names]
                    [:kyc-controlling-person/date-of-birth {:mandatory-field? process-not-in-draft-status?}]
                    [:kyc-controlling-person/place-of-birth {:mandatory-field? process-not-in-draft-status?}]
                    [:kyc-controlling-person/country-of-birth {:mandatory-field? process-not-in-draft-status?}]])}

   :kyc-controlling-person.group/address-information
   {:ord          2.0
    :translations {:en "Address information"
                   :fi "Osoitetiedot"}
    :questions    (questions-registry/resolve-questions
                   [[:kyc-controlling-person/street-address {:mandatory-field? process-not-in-draft-status?}]
                    [:kyc-controlling-person/city {:mandatory-field? process-not-in-draft-status?}]
                    [:kyc-controlling-person/country {:mandatory-field? process-not-in-draft-status?}]
                    [:kyc-controlling-person/zip-code {:mandatory-field? process-not-in-draft-status?}]
                    [:kyc-controlling-person/mailing-street-address]
                    [:kyc-controlling-person/mailing-city]
                    [:kyc-controlling-person/mailing-country]
                    [:kyc-controlling-person/mailing-zip-code]])}


   :kyc-controlling-person.group/relevant-entity-account-holders
   {:ord 4.0
    :translations {:en "Relevant Entity Account Holder(s)"}
    :questions (questions-registry/resolve-questions
                (concat
                 [[:kyc-controlling-person/lifeline-legal-names-of-the-entity-account-holders-for-which-is-controlling-person
                   {:optional-field? true}]]))}

   :kyc-controlling-person.group/declaration-of-us-citizenship-or-us-residence-for-tax-purposes
   {:ord 5.0
    :translations {:en "Declaration of U.S. Citizenship or U.S. Residence for Tax purposes"}
    :questions (questions-registry/resolve-questions
                (concat
                 [[:kyc-controlling-person/us-tax-status
                   {:mandatory-field? process-not-in-draft-status?}]
                  [:kyc-controlling-person/us-tin
                   {:conditional-field (fn [answers]
                                         (= :us-citizen (:kyc-controlling-person/us-tax-status answers)))
                    :mandatory-field? (fn [answers kyc-process]
                                        (and (= :us-citizen (:kyc-controlling-person/us-tax-status answers))
                                             (process-not-in-draft-status? answers kyc-process)))}]]))}

   :kyc-controlling-person.group/jurisdiction-of-residence-for-tax-purposes
   {:ord 6.0
    :translations {:en "Jurisdiction of Residence for Tax Purposes (other than the U.S.) and related Taxpayer Reference Number or functional equivalent (“TIN”)"}
    :questions (questions-registry/resolve-questions
                (concat
                 [[:kyc-controlling-person/tax-countries-info]
                  [:kyc-controlling-person/tax-countries]]))}

   :kyc-controlling-person.group/type-of-controlling-person
   {:ord 7.0
    :translations {:en "Type of Controlling Person"}
    :questions (questions-registry/resolve-questions
                (concat
                 [[:kyc-controlling-person/lifeline-type-of-controlling-person-info]
                  [:kyc-controlling-person/lifeline-type-of-controlling-person-edn
                   {:optional-field? true}]]))}})
